import { useCallback, useEffect, useRef, useState } from 'react';

const SCROLL_THRESHOLD = 2;

function useWrapperShadow({ scrollTreshold = SCROLL_THRESHOLD } = {}) {
  /** @type {import('react').MutableRefObject<HTMLElement>} */
  const scrollRef = useRef(null);
  const [left, setLeft] = useState(false);
  const [right, setRight] = useState(false);

  /** @param {Event} e */
  const onScroll = useCallback(
    (e) => {
      /** @type {HTMLElement} */
      const target = e?.target || scrollRef.current;

      const scrollRight = target.scrollWidth - target.offsetWidth - target.scrollLeft;

      setLeft(target.scrollLeft > scrollTreshold);
      setRight(scrollRight > scrollTreshold);
    },
    [setLeft, setRight]
  );

  useEffect(() => {
    if (!scrollRef.current) {
      return;
    }

    scrollRef.current.addEventListener('scroll', onScroll);

    return () => {
      scrollRef.current.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);

  useEffect(() => {
    const observer = new ResizeObserver(onScroll);
    const observerChild = new ResizeObserver(onScroll);

    if (!scrollRef.current) {
      return;
    }

    observer.observe(scrollRef.current);
    observerChild.observe(scrollRef.current.children[0]);

    return () => {
      observer.disconnect();
      observerChild.disconnect();
    };
  }, [onScroll]);

  return { ref: scrollRef, right, left };
}

export default useWrapperShadow;
